import { styled, Theme } from '@mui/material/styles';

import { VAR_AREA_TOP } from '@mopla/constants';

export const HeaderContainer = styled('div')<{ bgColor?: string }>(
	({ bgColor }) => ({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '12px 24px',
		backgroundColor: bgColor || 'transparent',
		minWidth: 0,
		overflow: 'hidden',

		'.withSafeAreaTop &': {
			padding: `calc(${VAR_AREA_TOP} + 12px) 16px 12px`,
		},
	})
);

export const profileHeaderTitleSx = (theme: Theme) => ({
	color: theme.palette.neutral[0],
	textAlign: 'center',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	minWidth: 0, // Allow text to shrink below content size
	maxWidth: '100%', // Ensure text doesn't exceed container width
});
